export const WORKFLOW_OPTIONS = {
  GENERAL: 0,
  PRE_JOB: 1,
  POST_JOB: 2,
  TIMESHEET: 3
};

export const WORKFLOW_KINDS = {
  GENERAL: 0,
  COMPLIANCE: 1,
  TIMESHEET: 2
};

export const WORKFLOW_NOTIFICATION_OPTIONS = {
  MINUTES: 'minutes',
  HOURS: 'hours',
  DAYS: 'days'
};

export const SEQUENCE_FIELDS_TYPE = {
  EMPLOYEE_FIELD: 0,
  PAYROLL_FIELD: 1,
  TIMESHEET_FIELD: 2
};

export const CaptainTypeEnum = {
  CAPTAIN_ONLY: 1,
  CAPTAIN_AND_EMPLOYEES: 2,
  EMPLOYEE: 3
};
